import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import React, { ReactNode } from 'react';
import { Card, CardContent, CardHeader, Container, Divider, Grid, TextFieldSkeleton, Typography } from '../..';
import BlankStateImage from '../assets/blank-state.svg';

interface SelectSetOverlayProps {
  classes: Partial<ClassNameMap<'container' | 'image' | 'descriptionText' | 'childSkeleton'>>;
  children?: ReactNode;
  cardHeaderTitle?: string;
  title?: string;
  description?: string;
  loading?: boolean;
}

export const SelectSetOverlay = ({
  classes,
  cardHeaderTitle = '',
  title = '',
  description = '',
  children,
  loading,
}: SelectSetOverlayProps) => {
  return (
    <Container className="fluid" data-testid="select-set-overlay-select-container">
      <Grid container>
        <Grid item xs={12}>
          <Card data-testid="select-set-overlay--card">
            <CardHeader title={cardHeaderTitle} />
            <Divider />
            <CardContent>
              <Grid container>
                <Grid item xs={4}>
                  <Grid container direction="column">
                    <Grid item data-testid="select-set-overlay--title">
                      <Typography color={'primary'} variant="h1">
                        {title}
                      </Typography>
                    </Grid>
                    <Grid item data-testid="select-set-overlay--description">
                      <Typography className={classes.descriptionText} variant="body2">
                        {description}
                      </Typography>
                    </Grid>
                    {loading ? <TextFieldSkeleton className={classes.childSkeleton} /> : children}
                  </Grid>
                </Grid>
                <Grid item xs={8} className={classes.image}>
                  <img src={BlankStateImage} />
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Container>
  );
};
